import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { TimePeriodSegmentedVizExternalProps } from '../../types';
import {
  TimePeriodSegmentedBarChartActions,
  TimePeriodSegmentedBarChartState,
} from './types';

export const useTimePeriodSegmentedBarChartStateManager = (
  // We might need more props later, but I am not sure
  externalProps: TimePeriodSegmentedVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  TimePeriodSegmentedBarChartState,
  TimePeriodSegmentedBarChartActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: true,
      enableStack: true,
      enableLabels: true,
      enableLegend: true,
      enableSortOrder: true,
      enableTableView: true,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions,
    },
  };
};
